module.exports = __webpack_public_path__ + "static/media/21.4966bc91.jpeg";